<template>
  <div class="app-container">
    <el-card shadow="always" class="card-box">
      <!-- 工具栏 -->
      <div class="filter-container">
        <el-row>
          <el-col :span="15">
            <el-input id="UserSearch-Guide" v-model="tableCondition.tableName" class="filter-item" clearable placeholder="数据源名称模糊搜索" style="width:200px;" />
            <el-select v-model="tableCondition.dataSourceType" class="filter-item" style="width: 150px" placeholder="数据源类型" clearable>
              <el-option label="hive" value="hive" />
              <el-option label="mysql" value="mysql" />
              <el-option label="doris" value="doris" />
            </el-select>
            <el-select v-model="tableCondition.createType" class="filter-item" style="width: 150px" placeholder="创建方式" clearable>
              <el-option label="表单" value="FORM" />
              <el-option label="DDL" value="DDL" />
              <el-option label="本地上传" value="local" />
            </el-select>
            <el-select v-model="tableCondition.createUser" class="filter-item" style="width: 150px" multiple placeholder="创建人" clearable>
              <el-option v-for="(item,index) in createUserOptions" :label="item.createUser" :value="item.createUserId" />
            </el-select>
            <el-select v-model="tableCondition.label" class="filter-item" multiple collapse-tags style="width: 220px" placeholder="标签" clearable filterable value-key="id">
              <el-option v-for="(item,index) in metaLabelsOptions" :label="item.labelName" :value="item.md5Id" />
            </el-select>
            <el-select v-model="tableCondition.updateFrequency" class="filter-item" multiple collapse-tags style="width: 220px" placeholder="更新频率" clearable filterable>
              <el-option v-for="(item,index) in updateFrequencyOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-button type="primary" class="filter-item" @click="getList">
              查询
            </el-button>
          </el-col>
          <el-col :span="9" style="display: flex;flex-wrap: wrap;">
            <el-button v-if="multipleTableData.length" type="primary" class="right-filter-item" size="small" icon="el-icon-circle-plus-outline" @click="batchSync">
              批量同步权限点
            </el-button>
            <el-button type="primary" class="right-filter-item" size="small" icon="el-icon-circle-plus-outline" @click="localUpload">
              本地上传
            </el-button>
            <el-button type="primary" class="right-filter-item" size="small" icon="el-icon-circle-plus-outline" @click="addTable">
              添加元数据
            </el-button>
            <el-button type="primary" class="right-filter-item" size="small" icon="el-icon-circle-plus-outline" @click="syncMetaData">
              同步元数据
            </el-button>
            <!--                        <div class="filterTableHeader">-->
            <!--                            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="batchSync" v-if="multipleTableData.length">-->
            <!--                                批量同步权限点-->
            <!--                            </el-button>-->
            <!--                        </div>-->
            <!--                        <div class="filterTableHeader">-->
            <!--                            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="localUpload">-->
            <!--                                本地上传-->
            <!--                            </el-button>-->
            <!--                        </div>-->
            <!--                        <div class="filterTableHeader">-->
            <!--                            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addTable">-->
            <!--                                添加元数据-->
            <!--                            </el-button>-->
            <!--                        </div>-->
            <!--                        <div class="filterTableHeader">-->
            <!--                            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="syncMetaData">-->
            <!--                                同步元数据-->
            <!--                            </el-button>-->
            <!--                        </div>-->

            <!-- table  筛选 -->
            <div class="right-filter-item">
              <el-popover width="600" trigger="click">
                <el-button slot="reference" class="button_style">
                  <svg-icon icon-class="combined_shape" />
                  <span class="button_span_style">筛选列</span>
                  <svg-icon icon-class="on_down" style="width:8px;height:8px;vertical-align: 0em;" />
                </el-button>
                <div class="checkbox-table-headers">
                  <template v-for="(item,index) in datasList.threads">
                    <el-checkbox :key="index" v-model="item.show" :disabled="index == 0||index == datasList.threads.length-1">
                      {{ item.name }}
                    </el-checkbox>
                  </template>
                </div>
              </el-popover>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--            表格-->
      <div v-loading="tableLoading" style="margin-top:10px;float:left;width:100%;">
        <!-- 表格 -->

        <el-table ref="grayTableTile_01" class="grayTableTile_01" border :data="datasList.rows" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <el-table-column
            type="selection"
            width="55"
          />
          <template v-for="(item,index) in datasList.threads">
            <el-table-column v-if="item.show&&item.property=='onlineStatus'" :label="item.name" :property="item.sortProperty" show-overflow-tooltip :sortable="item.sortFlag ? 'custom' : false">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.onlineStatus" :active-value="1" :inactive-value="0" @change="handleOnline(scope.row)" />
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.show&&item.property=='tableName'" :label="item.name" :property="item.sortProperty" align="center" :width="flexColumnWidth('tableName',datasList.rows)" :sortable="item.sortFlag ? 'custom' : false">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="seeMetaData(scope.row)">
                  {{ scope.row[item.property] }}
                </el-link>
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.show&&item.property=='updateFrequency'" :label="item.name" :property="item.sortProperty" :width="item.width" show-overflow-tooltip :sortable="item.sortFlag ? 'custom' : false">
              <template slot-scope="scope">
                <span>{{ updateFrequencyOptions.find(item=>item.value==scope.row.updateFrequency).label }}</span>
              </template>
            </el-table-column>

            <el-table-column v-else-if="item.show" :label="item.name" :property="item.sortProperty" :width="item.width" show-overflow-tooltip :sortable="item.sortFlag ? 'custom' : false">
              <template slot-scope="scope">
                <span>{{ scope.row[item.property] }}</span>
              </template>
            </el-table-column>
          </template>

          <el-table-column prop="address" label="操作" fixed="right" width="240">
            <template slot-scope="scope">
              <el-link v-if="scope.row.onlineStatus==0" :underline="false" type="primary" @click="editTable(scope.row)">
                编辑<span style="float: right;width: 1px;height: 16px;background: #cccccc; margin: 0px 10px; margin-top: 3px;" />
              </el-link>
              <el-link v-if="scope.row.onlineStatus==0" :underline="false" type="primary" @click="delTable(scope.row)">
                删除<span style="float: right;width: 1px;height: 16px;background: #cccccc; margin: 0px 10px; margin-top: 3px;" />
              </el-link>
              <el-link v-if="scope.row.onlineStatus==0" :underline="false" type="primary" @click="syncTable(scope.row)">
                同步<span style="float: right;width: 1px;height: 16px;background: #cccccc; margin: 0px 10px; margin-top: 3px;" />
              </el-link>
              <el-link v-if="scope.row.onlineStatus==0&&scope.row.oldFlag!=2" :underline="false" type="primary" @click="lookFile(scope.row)">
                查看
              </el-link>
              <el-link v-if="scope.row.onlineStatus==0&&scope.row.oldFlag==2" :underline="false" type="primary" @click="editFile(scope.row.md5Id)">
                更新数据
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="tableCondition.total" :page.sync="tableCondition.pageNum" :limit.sync="tableCondition.pageSize" style="margin-top:10px;padding:10px 0px 10px 0px" @pagination="getList" />
      </div>
    </el-card>

    <!--        删除弹窗-->
    <confirm-dialog ref="delDiaRef" @handleConfirm="handleDelete" />
    <!--        新增弹窗-->
    <metadata-dialog ref="metadataRef" @closeDia="getList" />
    <!--        本地上传弹窗-->
    <local-upload ref="uploadRef" @getList="getList" />
    <!--        同步元数据弹窗-->
    <sync-dialog ref="syncRef" @getList="getList" />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {
  queryBy_searchForm,
  update_batchSync,
  deleteBy_datas,
  update_onlineStatus,
  queryLabelBy,
  queryCreateUserBy,
  update_Sync
} from '@Dcs~/api/metadataList_model'
import { mapGetters } from 'vuex'
import ConfirmDialog from '../components/ConfirmDialog'
import MetadataDialog from '../components/MetadataDialog'
import LocalUpload from '../components/LocalUpload'
import SyncDialog from '../components/SyncDialog'

import { cloneDeep } from 'lodash' // 深拷贝
// import { checkName } from '@Dcs~/utils/validate'

export default {
  components: { Pagination, ConfirmDialog, MetadataDialog, LocalUpload, SyncDialog },
  data() {
    // 此处对metaDataSourceId数据源名称进行的校验，无论是添加还是编辑都需要与总数据库数据对比查重，所以需要发送请求
    return {
      tableCondition: {
        total: 0,
        tableName: '',
        pageNum: 1,
        pageSize: 10,
        orderByColumn: '', // 排序字段
        isAsc: 'desc', // 排序方式
        dataSourceType: '',
        createType: '',
        createUser: [],
        label: [],
        updateFrequency: []
      },

      metaLabelsOptions: [],
      createUserOptions: [],
      updateFrequencyOptions: [{ label: 'h+0', value: 1 }, { label: 'h+1', value: 2 }, { label: 't+1', value: 3 }, { label: 'w+1', value: 4 }, { label: 'm+1', value: 5 }, { label: '手动更新', value: 6 }, { label: 'h+0.5', value: 7 }],

      // 表格多选数据
      multipleTableData: [],

      datasList: {
        rows: [],
        threads: [
          { name: '表名称', property: 'tableName', sortFlag: false, sortProperty: 'tableName', show: true },
          {
            name: '数据源类型',
            property: 'dataSourceType',
            sortFlag: false,
            sortProperty: 'dataSourceType',
            width: 100,
            show: true
          },
          {
            name: '数据源名称',
            property: 'dataSourceName',
            sortFlag: false,
            sortProperty: 'dataSourceName',
            width: 100,
            show: true
          },
          {
            name: '数据库名称',
            property: 'dataBaseName',
            sortFlag: false,
            sortProperty: 'dataBaseName',
            width: 100,
            show: true
          },
          { name: '标签', property: 'metaLabels', sortFlag: false, sortProperty: 'metaLabels', show: true },
          {
            name: '负责人',
            property: 'tableAuthor',
            sortFlag: false,
            sortProperty: 'tableAuthor',
            show: true
          },
          {
            name: '表分层',
            property: 'hiveLayered',
            sortFlag: false,
            sortProperty: 'hiveLayered',
            show: true
          },
          {
            name: '上线状态',
            property: 'onlineStatus',
            sortFlag: false,
            sortProperty: 'onlineStatus',
            show: true
          },
          {
            name: '创建方式',
            property: 'createType',
            sortFlag: false,
            sortProperty: 'createType',
            show: true
          },
          {
            name: '创建时间',
            property: 'tableCreateTime',
            sortFlag: true,
            sortProperty: 'tableCreateTime',
            show: true,
            width: 200
          },
          {
            name: '更新频率',
            property: 'updateFrequency',
            sortFlag: false,
            sortProperty: 'updateFrequency',
            show: true
          },
          { name: '备注', property: 'tableDesc', sortFlag: false, sortProperty: 'tableDesc', show: true }
        ]
      },
      tableLoading: false

    }
  },

  mounted() {
    console.log('正式环境1')
    this.getList()
    queryLabelBy().then((res) => {
      if (res.code == 1) {
        this.metaLabelsOptions = res.data
        // 先把标签接口请求好
      }
    })
    queryCreateUserBy().then((res) => {
      if (res.code == 1) {
        this.createUserOptions = res.data
        console.log(this.createUserOptions)
        // 先把标签接口请求好
      }
    })
  },

  methods: {
    flexColumnWidth(str, arr1, flag = 'max') {
      console.log(str)
      // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
      // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
      // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
      str = str + ''
      let columnContent = ''
      if (!arr1 || !arr1.length || arr1.length === 0 || arr1 === undefined) {
        return '80px' // 给个默认的
      }
      if (!str || !str.length || str.length === 0 || str === undefined) {
        return '80px' // 给个默认的
      }
      if (flag === 'equal') {
        // 获取该列中第一个不为空的数据(内容)
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i][str].length > 0) {
            // console.log('该列数据[0]:', arr1[0][str])
            columnContent = arr1[i][str]
            break
          }
        }
      } else {
        // 获取该列中最长的数据(内容)
        let index = 0
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i][str] === null) {
            return
          }
          const now_temp = arr1[i][str] + ''
          const max_temp = arr1[index][str] + ''
          if (now_temp.length > max_temp.length) {
            index = i
          }
        }
        columnContent = arr1[index][str]
      }
      // console.log('该列数据[i]:', columnContent)
      // 以下分配的单位长度可根据实际需求进行调整
      let flexWidth = 0
      for (const char of columnContent) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
          // 如果是英文字符，为字符分配8个单位宽度
          flexWidth += 8
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
          // 如果是中文字符，为字符分配15个单位宽度
          flexWidth += 15
        } else {
          // 其他种类字符，为字符分配8个单位宽度
          flexWidth += 8
        }
      }
      if (flexWidth < 80) {
        // 设置最小宽度
        flexWidth = 80
      }
      // if (flexWidth > 250) {
      //   // 设置最大宽度
      //   flexWidth = 250
      // }

      // 可以再多留部分的padding
      flexWidth += 30
      return flexWidth + 'px'
    },

    handleOnline(row) {
      update_onlineStatus({ id: row.id, status: row.onlineStatus }).then((res) => {
        if (res.code != 1) {
          row.onlineStatus = row.onlineStatus == 0 ? 1 : 0
        }
      })
    },
    // 删除表
    delTable(row) {
      this.$refs['delDiaRef'].dialogVisible = true
      this.$refs['delDiaRef'].id = row.id
    },
    // 同步表
    syncTable(row) {
      update_Sync({ md5Id: row.md5Id }).then((res) => {
        if (res.code == 1) {
          this.$message({ message: '同步成功', type: 'success' })
          this.getList()
        }
      })
    },
    // 查看文件上传表
    lookFile(id, md5Id) {
      this.$refs['uploadRef'].lookFile(id, md5Id)
    },
    // 同步文件上传数据
    editFile(id) {
      this.$refs['uploadRef'].editFile(id)
    },
    handleDelete(id) {
      deleteBy_datas(id).then((res) => {
        if (res.code == 1) {
          this.$message({ message: '删除成功', type: 'success' })
          this.getList()
        }
      })
    },
    // 批量同步权限点
    batchSync() {
      console.log(this.multipleTableData)
      update_batchSync(this.multipleTableData).then(res => {
        if (res.code == 1) {
          this.$message({ message: '批量同步权限点成功', type: 'success' })
          this.$refs.grayTableTile_01.clearSelection()
        }
      })
    },
    // 本地上传
    localUpload() {
      this.$refs['uploadRef'].addFile()
    },
    // 新增表
    addTable() {
      this.$refs['metadataRef'].seeMetadata = false
      this.$refs['metadataRef'].init('add')
    },

    // 同步元数据
    syncMetaData() {
      this.$refs.syncRef.init()
    },

    editTable(row) {
      console.log(row)
      if (row.oldFlag == 2) {
        this.lookFile(row.id, row.md5Id)
        return
      }
      this.$refs['metadataRef'].seeMetadata = false
      this.$refs['metadataRef'].init(row)
    },
    seeMetaData(row) {
      if (row.oldFlag == 2) {
        this.lookFile(row.id, row.md5Id)
        return
      }
      this.$refs['metadataRef'].seeMetadata = true
      this.$refs['metadataRef'].init(row)
    },

    // 表格多选
    handleSelectionChange(val) {
      this.multipleTableData = val
    },

    // 列排序
    handleSortChange(e) {
      if (e.order === 'descending') {
        this.tableCondition.isAsc = 'DESC'
        this.tableCondition.orderByColumn = e.prop
        this.tableCondition.pageNum = 1
        this.getList()
      } else if (e.order === 'ascending') {
        this.tableCondition.isAsc = 'ASC'
        this.tableCondition.orderByColumn = e.prop
        this.tableCondition.pageNum = 1
        this.getList()
      }
    },

    getList() {
      this.tableLoading = true
      let metaLabel = ''
      this.tableCondition.labelMd5IdsString = this.tableCondition.label && this.tableCondition.label.join(',')
      this.tableCondition.label = null
      this.tableCondition.createUserIdsString = this.tableCondition.createUser && this.tableCondition.createUser.join(',')
      this.tableCondition.createUser = null
      const param = JSON.parse(JSON.stringify(this.tableCondition))
      param.updateFrequencyString = param.updateFrequency && param.updateFrequency.join(',')
      param.updateFrequency = null
      console.log(param)
      queryBy_searchForm(param).then((res) => {
        this.datasList.rows = res.data.rows
        this.datasList.rows.map((item) => {
          item.metaLabels.forEach((item2) => {
            console.log(item2)
            metaLabel = item2 == null ? '' : `${metaLabel}${metaLabel == '' ? '' : ','}${item2.labelName}`
          })
          item.metaLabels = metaLabel
          metaLabel = ''
          return item
        })
        this.tableCondition.total = res.data.total
        this.tableLoading = false
        this.tableCondition.label = this.tableCondition.labelMd5IdsString && this.tableCondition.labelMd5IdsString.split(',')
        this.tableCondition.createUser = this.tableCondition.createUserIdsString && this.tableCondition.createUserIdsString.split(',')
      })
    }
  }
}
</script>

<style lang="scss" scoped>

    .filterTableHeader {
        margin-right: 10px;
        float: right;
    }

    .button_style {
        font-size: 16px;
        padding: 8px 10px;
        border-radius: 6px;
        border: 1px solid #e5e5e5;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);

        .button_span_style {
            font-weight: 400;
            line-height: 18px;
            font-size: 14px;
            padding: 0px 5px 0px 0px;
        }
    }

    .el-form-item {
        margin-bottom: 15px;
    }

    .app-container {
        min-height: calc(100vh - 84px);
        background: #f0f2f5;
        padding: 0px 32px;
        padding-top: 23px;

        .filter-container{
            .right-filter-item{
                margin: 0px 10px 10px 0px;
                height: 32px;
            }
        }

        .el-card.is-always-shadow {
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 5%);
        }

        .card-box {
            padding: 4px;
            // ::v-deep .el-card__header {
            //   line-height: 30px;
            //   padding: 10px 15px;
            // }
        }

        > > > .el-select__tags {
            .el-tag {
                max-width: 60%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .el-select__input {
                margin-left: 2px;
            }
        }

        > > > .custom_form {
            .el-dialog__title {
                font-weight: 500;
                color: #333333;
                font-size: 20px;
            }

            .el-form-item__label {
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
    }

</style>
